module.exports = __webpack_public_path__ + "d1f52928af5369429747aa37acd3a5c1.svg";